import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056b1148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Online_Audience" }
const _hoisted_2 = { class: "dudience_nav" }
const _hoisted_3 = { class: "nav_headLeft" }
const _hoisted_4 = {
  key: 0,
  class: "nav_switch"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mask_tip" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "tip_highLight",
  style: {"color":"#00ccb0"}
}, "自定义菜单", -1))
const _hoisted_8 = { class: "nav_switch" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nav_title" }, "观看页显示", -1))
const _hoisted_10 = { class: "nav_mobile" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "chat_btn_box" }
const _hoisted_13 = { class: "chat_btn" }
const _hoisted_14 = {
  key: 1,
  class: "url_box"
}
const _hoisted_15 = ["src"]

import { ref, createVNode, computed, watch, onMounted, nextTick } from 'vue';
import { Popover, Switch, Input, Modal, message, Table } from 'ant-design-vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { useConsoleStore } from '@/pinia/console';
import http from '@/api';
import { useRoute } from 'vue-router';
import { nullImg } from '@/assets';
import { MemberClass, MemberDataObj } from '@/pinia/types/console';
import { useDebounce } from '@/hooks/useDebounce';
import MList, { Column } from './MList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberList',
  emits: ['click:toChat'],
  setup(__props, { emit }) {

const aPopover = Popover;
const aSwitch = Switch;
const aInputSearch = Input.Search;
const aTable = Table;

const isShowes = ref(0);
const consoleStore = useConsoleStore();
const route = useRoute();
const statued = ref(1);
// 搜索在线成员
const allList = ref<MemberClass[]>([]);
allList.value = consoleStore.memberList;

// S 私聊
const toChat = useDebounce((formData: any) => {
  emit('click:toChat');
  const data = new MemberDataObj(formData);
  consoleStore.chatType = 0;
  consoleStore.currentDialog.user = data;
  consoleStore.toDialogMsg(consoleStore.consoleInfo.id, data.to_uid);
});
// E 私聊

watch(
  () => consoleStore.memberList.length,
  () => {
    allList.value = consoleStore.memberList.filter((e) => (findOnline.value !== '' ? e.name.includes(findOnline.value) : true));
  }
);

const findOnline = ref('');

const findChange = () => {
  if (findOnline.value) {
    allList.value = consoleStore.memberList.filter((e) => {
      if (isShowes.value) {
        return e.device_type === isShowes.value && e.name.includes(findOnline.value);
      } else {
        return e.name.includes(findOnline.value);
      }
    });
  } else {
    allList.value = consoleStore.memberList.filter((e) => {
      if (isShowes.value) {
        return e.device_type === isShowes.value;
      } else {
        return e;
      }
    });
  }
};
const columns: Column[] = [
  {
    title: '头像',
    dataIndex: 'url',
    align: 'center',
    slots: { customRender: 'url' },
  },
  {
    title: '昵称',
    dataIndex: 'name',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '上线时间',
    dataIndex: 'visited_at',
    ellipsis: true,
    align: 'center',
  },
  {
    title: '设备',
    width: '28%',
    align: 'center',
    slots: { customRender: 'equipment' },
  },
];
// 观看页开关显示
const onChangeChatShow = () => {
  Modal.confirm({
    centered: true,
    icon: createVNode(ExclamationCircleFilled),
    content: '确认开启或关闭观看页聊天菜单？',
    onOk() {
      return new Promise((resolve, reject) => {
        http.liveInformation
          .getMemberSwitch({
            status: Number(!consoleStore.consoleInfo.memberVisible),
            studio_id: route.params.studioId,
          })
          .then(() => {
            consoleStore.consoleInfo.memberVisible = !consoleStore.consoleInfo.memberVisible;
            resolve({});
          })
          .catch((err: any) => {
            message.warn(err.data.error);
            reject(err);
          });
      });
    },
  });
};

// 群用户禁言
const groupMute = (item: any) => {
  let violat = {
    studio_id: route.params.studioId,
    status: statued.value,
    avatar: item.avatar,
    monitor_id: consoleStore.consoleInfo.monitorId,
    nickname: item.name,
    uid: item.uid,
  };
  http.liveInformation
    .getGroupMute(violat)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
        consoleStore.memberList.forEach((e) => {
          if (e.uid === item.uid) e.mute = 1;
        });
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
// 直播间拉黑用户
const pullBlack = (item: any, index: any) => {
  let pullblack = {
    studio_id: route.params.studioId,
    status: statued.value,
    avatar: item.avatar,
    monitor_id: consoleStore.consoleInfo.monitorId,
    nickname: item.name,
    uid: item.uid,
  };
  http.liveInformation
    .getPullBlack(pullblack)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
        consoleStore.memberList.splice(index, 1);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
const changeNumber = (type: number) => {
  findOnline.value = '';
  isShowes.value = type;
  switch (type) {
    case 1:
      allList.value = consoleStore.memberList.filter((e) => e.isPc === 1);
      break;
    case 2:
      allList.value = consoleStore.memberList.filter((e) => e.isMobile === 1);
      break;
    case 3:
      allList.value = consoleStore.memberList.filter((e) => e.isIpad === 1);
      break;
    default:
      allList.value = consoleStore.memberList;
      break;
  }
};

const have_member = ref(false);
// 获取自定义菜单
const MenuList = () => {
  let menu = {
    studio_id: route.params.studioId,
  };
  http.liveInformation.getMenu({ params: menu }).then((res) => {
    const menus = res.data.data.menu;
    const originData = res.data.data.origin_datas;
    menus.forEach((item: any, index: any) => {
      item.isActive = false;
      item.index = index;
    });
    originData.forEach((item: any) => {
      if (item.type_id == '7') {
        have_member.value = true;
      }
    });
  });
};
MenuList();

// 解禁
const setGroupMute = (item: any) => {
  let groupMute = {
    studio_id: route.params.studioId,
    status: 0,
    avatar: item.avatar,
    monitor_id: consoleStore.consoleInfo.monitorId,
    nickname: item.name,
    uid: item.uid,
  };
  http.liveInformation
    .getGroupMute(groupMute)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
        consoleStore.getMemberList(parseInt(route.params.studioId as string));
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

const mlistRef = ref<HTMLDivElement>();
const mlistHight = ref(0);
onMounted(() => {
  mlistRef.value && (mlistHight.value = mlistRef.value.offsetHeight);
});

watch(
  () => consoleStore.memberList.length,
  (newVal) => {
    if (mlistHight.value) return;
    if (newVal > 0) {
      nextTick(() => {
        mlistRef.value && (mlistHight.value = mlistRef.value.offsetHeight);
      });
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (have_member.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(" 观看页显示 "),
              _createVNode(_unref(aSwitch), {
                checked: _unref(consoleStore).consoleInfo.memberVisible,
                class: "nav_btn",
                size: "small",
                onChange: onChangeChatShow
              }, null, 8, ["checked"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(aPopover), { placement: "bottom" }, {
                content: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createTextVNode("请先在 "),
                    _createVNode(_component_router_link, {
                      to: { path: `/pages_editor/${_unref(route).params.studioId}/menu` },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createTextVNode("中添加成员列表")
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_unref(aSwitch), {
                      modelValue: have_member.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((have_member).value = $event)),
                      class: "nav_btn",
                      size: "small",
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ])),
        _createElementVNode("div", {
          class: _normalizeClass(["nav_people", { cutIsactive: isShowes.value === 0 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeNumber(0)))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": "live_chat_people",
            class: "nav_img"
          }),
          _createTextVNode(_toDisplayString(_unref(consoleStore).memberCount.allCount), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: _normalizeClass(["nav_computer", { cutIsactive: isShowes.value === 1 }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeNumber(1)))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": "live_chat_computer",
            class: "nav_img"
          }),
          _createTextVNode(_toDisplayString(_unref(consoleStore).memberCount.pcCount), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["nav_phone", { cutIsactive: isShowes.value === 2 }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeNumber(2)))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": "live_chat_phone",
            class: "nav_img"
          }),
          _createTextVNode(_toDisplayString(_unref(consoleStore).memberCount.mobileCount), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["nav_flag", { cutIsactive: isShowes.value === 3 }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeNumber(3)))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": "live_chat_flag",
            class: "nav_img"
          }),
          _createTextVNode(_toDisplayString(_unref(consoleStore).memberCount.padCount), 1)
        ], 2)
      ]),
      _createVNode(_unref(aInputSearch), {
        class: "nav_search",
        value: findOnline.value,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((findOnline).value = $event)),
        onSearch: _cache[6] || (_cache[6] = ($event: any) => (findChange())),
        placeholder: "搜索在线成员"
      }, null, 8, ["value"])
    ]),
    (_unref(consoleStore).memberList.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "mlistRef",
          ref: mlistRef,
          class: "dudience_content"
        }, [
          _withDirectives(_createVNode(MList, {
            columns: columns,
            "data-source": allList.value,
            "data-key": "uid",
            height: mlistHight.value
          }, {
            url: _withCtx(({ record }) => [
              _createElementVNode("img", {
                src: record.avatar_url,
                alt: "",
                style: {"width":"30px","height":"30px"}
              }, null, 8, _hoisted_11)
            ]),
            equipment: _withCtx(({ record, index }) => [
              (record.device_type == 1)
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 0,
                    "icon-class": "live_chat_computer",
                    class: "nav_img"
                  }))
                : _createCommentVNode("", true),
              (record.device_type == 2)
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 1,
                    "icon-class": "live_chat_phone",
                    class: "nav_img"
                  }))
                : _createCommentVNode("", true),
              (record.device_type == 3)
                ? (_openBlock(), _createBlock(_component_svg_icon, {
                    key: 2,
                    "icon-class": "live_chat_flag",
                    class: "nav_img"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_button, {
                    class: "btn_select",
                    onClick: ($event: any) => (groupMute(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("禁言")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (record.level != 1)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        class: "btn_select mar",
                        onClick: ($event: any) => (pullBlack(record, index))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("拉黑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_unref(consoleStore).consoleInfo.chatType === 2)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        class: "btn_select mar",
                        onClick: ($event: any) => (_unref(toChat)(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("私聊")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["data-source", "height"]), [
            [_vShow, mlistHight.value]
          ])
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("img", { src: _unref(nullImg) }, null, 8, _hoisted_15)
        ]))
  ]))
}
}

})